import { render } from "./DownloadTile.vue?vue&type=template&id=75aff48a&scoped=true"
import script from "./DownloadTile.vue?vue&type=script&lang=js"
export * from "./DownloadTile.vue?vue&type=script&lang=js"

import "./DownloadTile.vue?vue&type=style&index=0&id=75aff48a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75aff48a"]])

export default __exports__